'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('../FormInputs/Label');

var _Label2 = _interopRequireDefault(_Label);

var _MatrixRow = require('./MatrixRow');

var _MatrixRow2 = _interopRequireDefault(_MatrixRow);

var _MatrixChoiceLabels = require('./MatrixChoiceLabels');

var _MatrixChoiceLabels2 = _interopRequireDefault(_MatrixChoiceLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MatrixQuestion = function (_Component) {
  _inherits(MatrixQuestion, _Component);

  function MatrixQuestion(props) {
    _classCallCheck(this, MatrixQuestion);

    var _this = _possibleConstructorReturn(this, (MatrixQuestion.__proto__ || Object.getPrototypeOf(MatrixQuestion)).call(this, props));

    _this.componentDidMount = function () {
      _this.setState({
        labelOffsetTop: _this.labelNode.offsetTop
      });
      window.addEventListener('scroll', _this.handleScroll);
    };

    _this.componentWillUnmount = function () {
      window.removeEventListener('scroll', _this.handleScroll);
    };

    _this.handleScroll = function () {
      var top = window.pageYOffset || document.documentElement.scrollTop;
      if (!_this.state.scrolled && top >= _this.state.labelOffsetTop) {
        _this.setState({ scrolled: true });
      }
      if (_this.state.scrolled && top <= _this.state.labelOffsetTop) {
        _this.setState({ scrolled: false });
      }
    };

    _this.onMatrixChange = function (rowId, value) {
      var _this$props = _this.props,
          id = _this$props.id,
          onChange = _this$props.onChange;

      var answer = _extends({}, _this.state.answer, _defineProperty({}, rowId, value));
      _this.setState({ answer: answer });
      if (_this.shouldSubmitAnswer(answer)) {
        onChange(id, answer);
      }
    };

    _this.shouldSubmitAnswer = function (answer) {
      return _this.props.skippable || _this.fullyAnswered(answer);
    };

    _this.fullyAnswered = function (answer) {
      var questions = _this.props.columns.questions;
      var rows = _this.props.rows.values;
      return rows.every(function (row) {
        return answer[row.id] && questions.every(function (question) {
          return question.skippable || answer[row.id][question.id];
        });
      });
    };

    _this.setLabelRef = function (element) {
      _this.labelNode = element;
    };

    _this.state = {
      answer: props.answer,
      scrolled: false,
      labelOffsetTop: 0
    };
    return _this;
  }

  _createClass(MatrixQuestion, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var text = this.props.text;
      var _state = this.state,
          answer = _state.answer,
          scrolled = _state.scrolled;

      var questions = this.props.columns.questions;
      var rows = this.props.rows.values;
      return _react2.default.createElement(
        'div',
        { className: 'Matrix-root survey-question' },
        _react2.default.createElement(_Label2.default, { text: text }),
        _react2.default.createElement(_MatrixChoiceLabels2.default, {
          className: scrolled ? 'scrolled' : '',
          setRef: this.setLabelRef,
          questions: questions
        }),
        rows.map(function (row, i) {
          return _react2.default.createElement(_MatrixRow2.default, {
            answer: answer[row.id],
            key: i,
            row: row,
            questions: questions,
            onChange: _this2.onMatrixChange
          });
        })
      );
    }
  }]);

  return MatrixQuestion;
}(_react.Component);

MatrixQuestion.propTypes = {
  id: _propTypes2.default.string.isRequired,
  columns: _propTypes2.default.any.isRequired,
  rows: _propTypes2.default.any.isRequired,
  text: _propTypes2.default.string,
  answer: _propTypes2.default.object,
  displayType: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  skippable: _propTypes2.default.bool.isRequired
};

MatrixQuestion.defaultProps = {
  answer: {}
};

exports.default = MatrixQuestion;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Survey/MatrixQuestion.js
// module id = 454
// module chunks = 0